// extracted by mini-css-extract-plugin
module.exports = {"h1":"Headings_h1__hy49T","h2":"Headings_h2__G7EVK","h5":"Headings_h5__3EsuG"};